if (!customElements.get('cart-discount-code')) {
  class CartDiscountCode extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.input = this.querySelector('.js-discount-input');
      this.applyBtn = this.querySelector('.js-apply-discount');
      this.isSubmitting = false;
      this.submitHandler = this.handleSubmit.bind(this);
    }

    connectedCallback() {
      if (!this.form || !this.input) return;
      this.form.addEventListener('submit', this.submitHandler);
    }

    disconnectedCallback() {
      if (!this.form) return;
      this.form.removeEventListener('submit', this.submitHandler);
    }

    async handleSubmit(evt) {
      evt.preventDefault();

      if (this.isSubmitting) return;

      const code = this.input.value.trim();
      if (!code) {
        this.input.focus();
        return;
      }

      const root =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
      const redirectPath = `${window.location.pathname}${window.location.search}`;
      const url = `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirectPath)}`;

      this.setLoadingState(true);

      try {
        const response = await fetch(url, {
          method: 'GET',
          credentials: 'same-origin'
        });

        if (!response.ok) throw new Error(response.status);

        await this.refreshCartUI();
      } catch (error) {
        // Keep Shopify default behaviour as a fallback path.
        window.location.assign(url);
      } finally {
        this.setLoadingState(false);
      }
    }

    async refreshCartUI() {
      const cartItems = document.querySelector('cart-items');
      if (cartItems && typeof cartItems.refresh === 'function') {
        await cartItems.refresh();
        return;
      }

      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    }

    setLoadingState(isLoading) {
      this.isSubmitting = isLoading;
      this.setAttribute('aria-busy', isLoading ? 'true' : 'false');

      if (this.input) this.input.disabled = isLoading;
      if (this.applyBtn) this.applyBtn.disabled = isLoading;
    }
  }

  customElements.define('cart-discount-code', CartDiscountCode);
}
